module.exports = __webpack_public_path__ + "static/1-cb1b64619e2beaf06470ec375cac8129.jpg";